import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { actions as navigationActions } from 'actions/Navigation'

import Navbar from 'components/Navbar'
import Sidebar from 'components/Sidebar'

export class App extends Component {
  state = {
    authenticated: true,
  }

  render() {
    const { isDeployed, deploySidebar, dockSidebar } = this.props
    return (
      <div id="app">
        <Sidebar isDeployed={isDeployed}>
          <Navbar
            authenticated={this.state.authenticated}
            isDeployed={isDeployed}
            deploySidebar={deploySidebar}
            dockSidebar={dockSidebar}
          />
          <div style={{ minHeight: 'calc(100vh - 64px)', marginTop: 96 }}>
            {React.cloneElement(this.props.children, this.props)}
          </div>
        </Sidebar>
        <ToastContainer />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {
    navigation: { isDeployed },
  } = state

  return {
    isDeployed,
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      ...navigationActions,
    },
  )(App),
)
